import { ReactNode, useEffect } from 'react';

import { useModalContext } from '../modal.context';

import styles from './modal-components.module.css';

export type ModalSkipProps = {
  onSkip: VoidFunction;
  children?: ReactNode;
};

export const ModalSkip = ({ onSkip, children = 'skip' }: ModalSkipProps) => {
  const { mountSkipButton } = useModalContext();

  useEffect(mountSkipButton, [mountSkipButton]);

  return (
    <button className={styles.skipButton} onClick={onSkip}>
      {children}
    </button>
  );
};
